import template from './rw-retailer-info.html';

export default class RwRatailerInfoComponent {
  constructor() {
    this.template = template;
    this.bindings = {
      retailer: '<',
      shortInfo: '<',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-retailer-info/rw-retailer-info-component.js